import apiCall from "./call";
import { throttle } from "lodash";

const settingsApi = {
   roles: {
      fetchRoles() {
         return apiCall.get('roles');
      },
      paginateRoles(data) {
         return apiCall.get(`roles?page=${data.page}`);
      },

      filterRoles( q ) {
         return apiCall.get(`roles?q=${q}`);
      },


      saveNewRole( data ) {
         return apiCall.post('roles', { ...data })
      },

      updateRole( id, data ) {
         return apiCall.put(`roles/${id}`, { ...data })
      },

      fetchRole( id ) {
         return apiCall.get(`roles/${id}`)
      },

      deleteRole( id ) {
         return apiCall.delete(`roles/${id}`)
      }
   },

   categories: {
      fetchCategories() {
         return apiCall.get('categories');
      },
      paginateCategories(data) {
         return apiCall.get(`categories?page=${data.page}`);
      },

      filterCategories( q ) {
         return apiCall.get(`categories?q=${q}`);
      },

      saveNewCategory( data ) {
         return apiCall.post('categories', { ...data })
      },

      updateCategory( id, data ) {
         return apiCall.put(`categories/${id}`, { ...data })
      },

      fetchCategory( id ) {
         return apiCall.get(`categories/${id}`)
      },

      deleteCategory( id ) {
         return apiCall.delete(`categories/${id}`)
      }
   },

   suppliers: {
      fetchSuppliers: () => apiCall.get('suppliers'),
      paginateSuppliers: (data) => apiCall.get(`suppliers?page=${data.page}`),

      filterSuppliers: ( q ) => apiCall.get(`suppliers?q=${q}`),

      saveNewSupplier: ( data ) => apiCall.post('suppliers', { ...data }),

      updateSupplier: ( id, data ) => apiCall.put(`suppliers/${id}`, { ...data }),

      fetchSupplier: ( id ) => apiCall.get(`suppliers/${id}`),

      deleteSupplier: ( id ) => apiCall.delete(`suppliers/${id}`)
   },

   customers: {
      fetchCustomers() {
         return apiCall.get('customers');
      },
      paginateCustomers(data) {
         return apiCall.get(`customers?page=${data.page}`);
      },

      filterCustomers( q ) {
         return apiCall.get(`customers?q=${q}`)
      },

      saveNewCustomer( data ) {
         return apiCall.post('customers', { ...data })
      },
      saveNewCustomerShortData( data ) {
         return apiCall.post('customers-short-data', { ...data })
      },

      updateCustomer( id, data ) {
         return apiCall.put(`customers/${id}`, { ...data })
      },

      fetchCustomer( id ) {
         return apiCall.get(`customers/${id}`)
      },

      deleteCustomer( id ) {
         return apiCall.delete(`customers/${id}`)
      }
   },
   branches: {
      fetchBranches() {
         return apiCall.get('branches');
      },

      filterBranches( q ) {
         return apiCall.get(`branches?q=${q}`)
      },

      saveNewBranch( data ) {
         return apiCall.post('branches', { ...data })
      },

      updateBranch( id, data ) {
         return apiCall.put(`branches/${id}`, { ...data })
      },

      fetchBranch( id ) {
         return apiCall.get(`branches/${id}`)
      },

      deleteBranch( id ) {
         return apiCall.delete(`branches/${id}`)
      }
   },

   users: {
      fetchUsers() {
         return apiCall.get('users');
      },
      paginateUsers(data) {
         return apiCall.get(`users?page=${data.page}`);
      },

      filterUsers( q ) {
         return apiCall.get(`users?q=${q}`)
      },

      saveNewUser( data ) {
         return apiCall.post('users', { ...data })
      },

      updateUser( id, data ) {
         return apiCall.put(`users/${id}`, { ...data })
      },

      fetchUser( id ) {
         return apiCall.get(`users/${id}`)
      },

      fetchOwnInfo() {
         return apiCall.get(`account-settings`)
      },
      updateProfile( id, data ) {
         return apiCall.post(`account-settings/${id}/edit`, { ...data })
      },
      updatePassword( id, data ) {
         return apiCall.post(`account-settings/${id}/update-password`, { ...data })
      },

      deleteUser( id ) {
         return apiCall.delete(`users/${id}`)
      },

      activeUser( id ) {
         return apiCall.post(`users/${id}/active`)
      },
      resetUserPassword( id ) {
         return apiCall.post(`users/${id}/reset-password`)
      },
      fetchUsersActivities() {
         return apiCall.get('activities');
      },
      filterUsersActivities( user_id, start_date, end_date ) {
         return apiCall.get('activities', {
            params: {
               user_id,
               start_date,
               end_date
            }
         })
      },
   },

   permissions: {
      fetchPermissions() {
         return apiCall.get('permissions');
      },
      paginatePermissions(data) {
         return apiCall.get(`permissions?page=${data.page}`);
      },

      filterPermissions( q ) {
         return apiCall.get(`permissions?q=${q}`)
      },


      saveNewPermission( data ) {
         return apiCall.post('permissions', { ...data })
      },

      updatePermission( id, data ) {
         return apiCall.put(`permissions/${id}`, { ...data })
      },

      fetchPermission( id ) {
         return apiCall.get(`permissions/${id}`)
      },

      deletePermission( id ) {
         return apiCall.delete(`permissions/${id}`)
      }
   },

   company_profile: {
      fetchCompanyProfile() {
         return apiCall.get('company-profile')
      },
      findCompanyProfile( id ) {
         return apiCall.get(`company-profile/${id}`)
      },
      updateCompanyProfile( id, data ) {
         return apiCall.put(`company-profile/${id}`, { ...data })
      }
   },

   productInfo: {
      save: ( data ) => apiCall.post('products', { ...data }),

      update: ( id, data ) => apiCall.put(`products/${id}`, { ...data }),

      delete: ( id ) => apiCall.delete(`products/${id}`),

      find: ( id ) => apiCall.get(`products/${id}`),

      paginate: (data = false, q = '') => apiCall.get(`products?page=${data.page?data.page:1}&q=${q}`),

      search: ( q, page = 1) => apiCall.get(`products?q=${q}`),

      itemsForCosting: () => apiCall.get('products-raw-materials'),
   },

   productReceive: {
      save: ( data ) => apiCall.post('products-receive', { ...data }),
      update: ( id, data ) => apiCall.put(`products-receive/${id}`, { ...data }),
      delete: ( id ) => apiCall.delete(`products-receive/${id}`),
      find: ( id ) => apiCall.get(`products-receive/${id}`),
      paginate: () => apiCall.get('products-receive'),
      search: ( q ) => apiCall.get(`products-receive?q=${q}`),

      // itemsForCosting: () => apiCall.get('products-receive')
   },

   materialInfo: {
      save( data ) {
         return apiCall.post('raw-materials', { ...data })
      },

      update( id, data ) {
         return apiCall.put(`raw-materials/${id}`, { ...data })
      },

      delete( id ) {
         return apiCall.delete(`raw-materials/${id}`)
      },

      find( id ) {
         return apiCall.get(`raw-materials/${id}`)
      },

      paginate(data = false) {
         return apiCall.get(`raw-materials?page=${data.page?data.page:1}`);
      },
      search: ( q ) => apiCall.get(`raw-materials?q=${q}`),

      fetchByHsCode: throttle(tariffSchedules => apiCall.get(`fetch-tariffSchedules/${tariffSchedules}`), 400),
   },

   costing: {
      save: ( productId, data ) => apiCall.post(`products/${productId}/costing`, { ...data }),
      fetchProductCost: ( productId ) => apiCall.get(`product-cost/${productId}`),
      update: ( costingId, payload ) => apiCall.put(`products/${costingId}/costing`, payload),
      deny: costingId => apiCall.patch(`product-cost/${costingId}/deny`),
      approve: costingId => apiCall.patch(`product-cost/${costingId}/approve`),
      delete: costingId => apiCall.delete(`product-cost/${costingId}/delete`),
      productCostings: productId => apiCall.get(`costings/${productId}`),
      productCostingsActivity: productId => apiCall.get(`costings/${productId}/activities`),
      materialCostingsActivity: materialId => apiCall.get(`raw-materials/${materialId}/activities`),
      find: id => apiCall.get(`product-costing/${id}`),
      saveOrUpdate: ( productId, data ) => apiCall.post(`products/${productId}/costing`, { ...data }),
   },

   otherExpenses: {
      fetchList: () => apiCall.get('other-expenses'),
      save: ( data ) => apiCall.post('other-expenses', { ...data }),

      // update( id, data ) {
      //    return apiCall.put(`raw-materials/${id}`, {...data})
      // },
      //
      // delete( id ) {
      //    return apiCall.delete(`raw-materials/${id}`)
      // },
      //
      // find( id ) {
      //    return apiCall.get(`raw-materials/${id}`)
      // },
      //
      // paginate() {
      //    return apiCall.get('raw-materials');
      // },
      // search: ( q ) => apiCall.get(`raw-materials?q=${q}`)
   },
   inventories: {
      fetchList: () => apiCall.get('inventories'),
      save: ( data ) => apiCall.post('inventories', { ...data }),
   },
   vatTypes: {
      fetchList: () => apiCall.get('vat-types'),
      save: ( data ) => apiCall.post('vat-types', { ...data }),
   },

   surcharge: {
      fetchList: () => apiCall.get('surcharges'),
      save: ( data ) => apiCall.post('surcharges', { ...data }),
   },
   stockReport: {
      fetchStockReport: (q) => apiCall.get(`stock-report?q=${q}`)
   },
   productSize: {
      fetchList: () => apiCall.get('product-size'),
      save: ( data ) => apiCall.post('product-size', { ...data }),
   }
}

export default settingsApi;
